import ReactDOM from 'react-dom';
import React from 'react';

import loadTranslations from '@utils/localeSetup';
import Routing from './Routing';

(async () => {
  const rootElement = document.getElementById('root');
  await loadTranslations();

  if (rootElement) {
    ReactDOM.render(<Routing />, rootElement);
  }
})();
